// extracted by mini-css-extract-plugin
export default {"section":"ContactsList_section__IE6+j","title":"ContactsList_title__Nc-fb"};